import { getLegacyGalleryLocation } from '~/utils/galleryRoutes'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/') return
  return navigateTo(getLegacyGalleryLocation(to.query), { replace: true })
})
